const jquery = $;

$.fn.extend({
  handleSelectRealizationImageInFileManager() {
    $('[data-modal-type="realization_images_file_manager_frame"]').on('load', function () {
      const $this = $(this);
      const $frame = $(this).contents();

      $(this).contents()
        .on('click', '.select', function () {
          const $modal = $('[data-modal-type="realization_images_file_manager"]');
          const $collection = $('[data-tab="media"]').find('[data-form-type="collection"]')
          const $list = $collection.find('[data-form-collection="list"]:first');

          const $path = $(this).attr('data-path');

          const $imageIndex = $this.attr('data-image-index');

          if ($imageIndex) {
            const $element = $list.find(`[data-form-collection-index="${$imageIndex}"]`);

            $element.find('[data-modal-type="path"]').val($path);
            $element.find('[data-modal-type="image"]').attr('src', $path);
            $element.find('[data-modal-type="header"]').text(decodeURI($path.split('/').pop()));
            $element.find('[data-modal-type="description"]').text(decodeURI($path));

            $modal.modal('hide');

            return;
          }

          const $count = $list.children().length;
          const $index = $count + 1;

          let prototype = $collection.data('prototype');
          let prototypeName = new RegExp($collection.data('prototype-name'), 'g');

          const $prototype = $(prototype.replace(prototypeName, $index));

          $prototype.find('[data-modal-type="path"]').val($path);
          $prototype.find('[data-modal-type="sequence"]').val($index);
          $prototype.find('[data-modal-type="image"]').attr('src', $path);
          $prototype.find('[data-modal-type="header"]').text(decodeURI($path.split('/').pop()));
          $prototype.find('[data-modal-type="description"]').text(decodeURI($path));

          $list.append($prototype);

          $(document).trigger('collection-form-add', [$list.children().last()]);

          $modal.modal('hide');

          jquery(document).handleOpenRealizationImagesModal();
        })
        .on('click', '#js-add-multiple', function () {
          const $imageIndex = $this.attr('data-image-index');

          if ($imageIndex) return;

          const $modal = $('[data-modal-type="realization_images_file_manager"]');
          const $collection = $('[data-tab="media"]').find('[data-form-type="collection"]')
          const $list = $collection.find('[data-form-collection="list"]:first');

          const $children = $frame.find('.checkbox:checked');

          $children.each(function () {
            $(this).prop('checked', false);

            const $value = $(this).val();
            const $path = $frame.find(`[data-value="${$value}"]`).attr('data-path');

            if (!$path) return;

            const $count = $list.children().length;
            const $index = $count + 1;

            let prototype = $collection.data('prototype');
            let prototypeName = new RegExp($collection.data('prototype-name'), 'g');

            const $prototype = $(prototype.replace(prototypeName, $index));

            $prototype.find('[data-modal-type="path"]').val($path);
            $prototype.find('[data-modal-type="sequence"]').val($index);
            $prototype.find('[data-modal-type="image"]').attr('src', $path);
            $prototype.find('[data-modal-type="header"]').text($value);
            $prototype.find('[data-modal-type="description"]').text(decodeURI($path));

            $list.append($prototype);

            $(document).trigger('collection-form-add', [$list.children().last()]);
          })

          $frame.find('#select-all').prop('checked', false);
          $modal.modal('hide');

          jquery(document).handleOpenRealizationImagesModal();
        })
    });
  },
  handleOpenRealizationImagesModal() {
    $('[data-action="open-realizations-images-modal"]').click(function () {
      const $fileManagerFrame = $('[data-modal-type="realization_images_file_manager_frame"]')
      const $imageIndex = $(this).attr('data-index')

      typeof $imageIndex !== 'undefined'
        ? $fileManagerFrame.attr('data-image-index', $imageIndex)
        : $fileManagerFrame.removeAttr('data-image-index')

      const $configuration = $(this).attr('data-file-manager-conf')
      const $route = $(this).attr('data-file-manager-route')

      const $src = $fileManagerFrame.attr('src');

      const url = $src.split('?');
      const params = new URLSearchParams(url[1]);

      params.set('conf', $configuration);
      params.set('route', $route);

      $fileManagerFrame.attr('src', `${url[0]}?${params.toString()}`);

      $('[data-modal-type="realization_images_file_manager"]').modal('show');
    })
  },
  handleRealizationImageMediumChange(e) {
    const $target = $(e.target);
    if (!$target.hasClass('realization-image-medium-field')) {
      return;
    }
    const $row = $target.closest('tr');
    const value = $target.val();

    if (value === 1 || value === '1') {
      $row.find('.image-preview').addClass('hidden');
      $row.find('.image-form').addClass('hidden');
      $row.find('.text-form').removeClass('hidden');
      $row.find('.realization-image-marginTop-field option[value="small"]').prop('selected', true);
    } else {
      $row.find('.text-form').addClass('hidden');
      $row.find('.image-preview').removeClass('hidden');
      $row.find('.image-form').removeClass('hidden');
      $row.find('.realization-image-marginTop-field option[value="large"]').prop('selected', true);
    }
  },
  handleNewRealizationImageRow() {
    const $row = $(this);
    const $mediumTypeSelect = $row.find('.realization-image-medium-field');
    const value = $mediumTypeSelect.val();

    if (value === 1 || value === '1') {
      $row.find('.realization-image-marginTop-field option[value="small"]').prop('selected', true);
    } else {
      $row.find('.realization-image-marginTop-field option[value="large"]').prop('selected', true);
    }
  },
});

jquery(document).ready(() => {
  jquery(document).handleSelectRealizationImageInFileManager();
  jquery(document).handleOpenRealizationImagesModal();

  jquery(document).on('collection-form-add', function () {
    jquery(document).handleOpenRealizationImagesModal();
    jquery('.realization-images-sortable-list tr:last-of-type').handleNewRealizationImageRow();
  });

  jquery(document).on('change', function (e) {
    jquery(document).handleRealizationImageMediumChange(e);
  });
});
